
export default class TutorialController {

	constructor (tutorial, $sce) {
		this.content = $sce.trustAsHtml(tutorial);
	}

}

TutorialController.$inject = ['tutorial', '$sce'];



// WEBPACK FOOTER //
// ./src/page/tutorial/tutorial.controller.js